<script>
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: { PhxIcon },

  props: {
    to: { type: String, required: true },
    label: { type: String, required: true },
    icon: { type: String, default: null },
    mobileOnly: { type: Boolean, default: false },
    desktopOnly: { type: Boolean, default: false },
    followStoreLinkOnClick: { type: Boolean, default: true },
  },

  emits: ['click'],

  computed: {
    btnClasses() {
      return [
        'btn',
        'btn--default',
        'btn--sm',
        'store-finder-modal__button',
        this.mobileOnly ? 'hidden max-sm:block' : '',
        this.desktopOnly ? 'hidden md:flex' : '',
        this.icon ? 'btn--icon' : '',
      ].join(' ');
    },
  },

  methods: {
    handleClick(event) {
      if (!this.followStoreLinkOnClick) {
        event.preventDefault();
        this.$emit('click', event);
      }
    },
  },
};
</script>

<template>
  <a :href="to" :class="btnClasses" @click="handleClick">
    <span class="btn__text">{{ label }}</span>
    <span v-if="icon" class="btn__icon">
      <phx-icon :icon="icon" />
    </span>
  </a>
</template>
